import React from 'react';
import Header from './Header';
import SubHeader from './SubHeader';
import Footer from './Footer';

const Layout = ({ children, title = '', subtitle = null }) => {
    const hasSubheader = title.length > 0 || subtitle !== null;
    
    return (
        <div className="flex flex-col items-stretch h-screen">
            <Header />
            { hasSubheader && (
                <SubHeader className='mt-20' title={title} subtitle={subtitle} content={null} />
            )}
            <div className={`flex-1 ${hasSubheader ? '' : 'mt-20'}`}>
                {children}
            </div>
            <Footer />
        </div>
    );
};

export default Layout;